<template>
  <section class="main-content w-100" id="tss">
    <div v-if="pdf.data" id="pdfRender" class="w-100">
      <PdfViewer :pdfUrl="pdf.data.url" :nomeApostila="nomeApostila" />
    </div>
    <b-container v-else class="content-error w-100">
      <div class="d-flex flex-column align-items-center">
        <h2><i class="fa-regular fa-triangle-exclamation fa-xl"></i></h2>
        <p class="lead">Há uma instabilidade ou o tempo de carregamento expirou.</p>
        <p>Se deseja continuar no conteúdo, volte a página e selecione o arquivo.</p>
        <b-button id="btn_goBack" variant="transparent" @click="goBack()">Voltar</b-button>
      </div>
    </b-container>
  </section>
</template>

<script>
import ApiService from '../../../common/api.service'
import PdfViewer from './PdfViewer.vue'

export default {
  props: {
    paramsForUrl: {
      type: String,
      required: true,
    },
    nomeApostila: {
      type: String,
      required: true,
    },
    material: {
      type: String,
      required: true,
    }
  },
  components: {
    PdfViewer,
  },
  data() { return { pdfUrl: '', pdf: [], url: '', } },
  mounted() { this.postData() },
  methods: {
    async postData() {
      await ApiService.get('v1/pdf-content', { paramsForUrl: this.$route.params.paramsForUrl })
        .then((response) => {
          this.pdf = response
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => { })
    },

    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.content-error,
#pdfRender {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

#btn_goBack {
  display: inline-block;
  min-width: 135px;
  margin-bottom: 0;
  font-weight: 700;

  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;

  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  background-image: none;
  padding: 8px 16px;
  background: linear-gradient(90deg,
      rgb(239, 50, 66) 0%,
      rgb(239, 50, 66) 50%,
      rgb(239, 72, 87) 50%,
      rgb(239, 72, 87) 100%);
  background-size: 200% 100%;
  background-position: right;
  color: #fff;
  transition: background 0.5s ease-in-out;
  border-radius: 0;
  text-transform: uppercase;
  letter-spacing: 1.25px !important;
  text-align: center;
  outline: center;

  font-size: 14px;

  text-decoration: none;

  border-radius: 4px;
}

#btn_goBack:hover {
  background-position: left;
}
</style>
